/**
 * Tab Component
 *
 * @file tab.js
 */

const tabs = (() => {
  /**
   * Default Tab
   * Project default tab style
   */
  
  const defaultTab = () => {
    const loginPopBtn = document.querySelectorAll('[data-modal-tab]');
    const newTabList = document.querySelectorAll('.default-tab-item');
    const newContentSections = document.querySelectorAll('.default-tab-content');

    loginPopBtn.forEach(btn => {
      btn.addEventListener('click', (event) => {
          const modalTabIndex = btn.getAttribute('data-modal-tab');
          newTabList.forEach(t => t.classList.remove('active'));
          newContentSections.forEach(section => section.classList.remove('active'));
          newTabList[modalTabIndex].classList.add('active');
          newContentSections[modalTabIndex].classList.add('active');
      });
    });

    newTabList.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
            event.preventDefault();

            newTabList.forEach(t => t.classList.remove('active'));
            newContentSections.forEach(section => section.classList.remove('active'));

            tab.classList.add('active');
            newContentSections[index].classList.add('active');
        });
    });
  };
  const homeVideoTab = () => {
    const tabList = document.querySelectorAll('.home-accordion .ac-list .item');
    const contentSections = document.querySelectorAll('.home-accordion .ac-content');

    tabList.forEach((tab, index) => {
        tab.addEventListener('mouseenter', () => {
            tabList.forEach(t => t.classList.remove('active'));
            contentSections.forEach(section => {
                section.classList.remove('tb-active');
                section.querySelector('.img').classList.remove('hovered');
            });

            tab.classList.add('active');
            contentSections[index].classList.add('tb-active');
            contentSections[index].querySelector('.img').classList.add('hovered'); 
            const firstItem = document.querySelector('.ac-content-first-item');
            if (firstItem) {
                firstItem.classList.remove('first-active'); 
            }
        });

        tab.addEventListener('mouseleave', () => {
            tab.classList.remove('active');
            contentSections[index].classList.remove('tb-active');
            contentSections[index].querySelector('.img').classList.remove('hovered');

            const firstItem = document.querySelector('.ac-content-first-item');
            if (firstItem) {
                firstItem.classList.add('first-active');
            }
        });
    });
  };
  
  const productButtonTab = () => {
    const threeItemButton = document.querySelector('.product-three-item-list');
    const fourItemButton = document.querySelector('.product-four-item-list');
    const productListItem = document.querySelector('.page-product-list-item');

    if(threeItemButton){

      function setActiveButton(activeButton) {
        threeItemButton.classList.remove('active');
        fourItemButton.classList.remove('active');
        
        activeButton.classList.add('active');
      }

      threeItemButton.addEventListener('click', function() {
        productListItem.classList.remove('four-item-list');
        productListItem.classList.add('three-item-list'); 
        setActiveButton(threeItemButton); 
      });

      fourItemButton.addEventListener('click', function() {
        productListItem.classList.remove('three-item-list');
        productListItem.classList.add('four-item-list');
        setActiveButton(fourItemButton);
      });
      
    }
  };
  
  const productSelect = () => {
    const filterItemContainer = document.querySelector('.filter-select-popup');
    const filterItems = document.querySelectorAll('.filter-box-item .filter-selected-item');
    const filterOpenBtn = document.querySelector('.product-filter .filter-add');
    const filterClose = document.querySelector('.filter-pop-close');

    if(filterOpenBtn){
      filterOpenBtn.addEventListener('click', function() {
        filterItemContainer.classList.add('filter-active');
      });

      filterClose.addEventListener('click', function() {
        filterItemContainer.classList.remove('filter-active');
      });

      filterItems.forEach(item => {
        item.addEventListener('click', function() {
          item.classList.toggle('active');  // Tıkladığında active class'ı toggle eder
        });
      });
    }
  };
  
  const payStepTab = () => {
    const tabContainers = document.querySelectorAll('.step-tab-container');
    if (tabContainers.length > 0) { // Eğer sayfada tab varsa
      tabContainers.forEach(container => {
        const tabItems = container.querySelectorAll('.step-tab-item');
        const contents = container.querySelectorAll('.step-tab-content');

        tabItems.forEach(item => {
          item.addEventListener('click', function() {
            const tabId = this.getAttribute('data-tab');
            tabItems.forEach(tab => tab.classList.remove('step-active'));

            this.classList.add('step-active');

            contents.forEach(content => content.classList.remove('step-active'));

            const activeContent = container.querySelector(`.step-tab-content[data-content="${tabId}"]`);
            if (activeContent) {
              activeContent.classList.add('step-active');
            }
          });
        });
      });
    }
  };

  const init = () => {
    defaultTab();
    homeVideoTab();
    productButtonTab();
    productSelect();
    payStepTab();
  };

  return {
    init,
  };
})();

export default tabs;
